import { useUserStore } from '@/store/modules/user'

export function authPermission(permission) {
  const all_permission = "*:*:*";
  const permissions = useUserStore().getPermission
  console.log('authPermission', permissions)
  if (permission?.length > 0) {
    return permissions.some(v => {
      return all_permission === v || permission.includes(v)
    })
  } else {
    return false
  }
}